import creator from "./creator.js";
import select from "./select.js";

export default function(name) {
  return select(creator(name).call(document.documentElement));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/create.js
// module id = 660
// module chunks = 0